import historicoPedidoModel from "./historicoPedido";
import clienteModel from "./cliente";
const TYPE = "produto";
const moment = require("moment");
const fields = [
  "_id",
  "_rev",
  "idIntegracao",
  "idFamilia",
  "idGrupo",
  "cod",
  "desc",
  "unid",
  "fracionado",
  "status",
  "dtCadastro",
  "descTecnica",
  "estoque",
  "imgIntegracao",
  "cdBarras",
  "giro",
  "precoPadrao",
  "precoPromocional",
  "type",
  "imagens",
  "descFormat",
  "primeiraLetra",
  "comissao",
];

let queryParametros = {
  selector: {
    type: { $eq: "parametros" },
  },
  limit: 1
};

const produtoModule = {
  findByDesc: async (
    dbConnection,
    idIntegracaoCliente,
    desc,
    buscaPadrao,
    skip,
    filtro = {
      familia: null,
      grupo: null,
    }
  ) => {
    let produtos = [];
    //const configuracao = await dbConnection.get("configuracao");
    let parametros = await dbConnection.find(queryParametros);
    parametros = parametros.docs[0];

    desc = replaceCaracEspeciais(desc.toUpperCase());

    let fieldsBusca = [].concat(fields);
    let tabelaPreco = null;

    if (idIntegracaoCliente !== "null") {
      idIntegracaoCliente = parseInt(idIntegracaoCliente);
      let cliente = await clienteModel.findTabelaPreco(
        dbConnection,
        idIntegracaoCliente
      );

      if (cliente.tabelaPreco !== null && cliente.tabelaPreco !== undefined) {
        fieldsBusca.push(`tabela-${cliente.tabelaPreco.idIntegracao}`);
        tabelaPreco = cliente.tabelaPreco;
      }
    }

    let pesquisaPrimeiraLetra = true;
    let primeiraLetra = desc.substring(0, 1);
    if (desc.substring(0, 1) === "%" || desc.substring(0, 1) === "&") {
      pesquisaPrimeiraLetra = false;
    }

    // Este comando serve pra fixar o começo da descrição na busca (Ex: FACA vai procurar tudo que começa com FACA).
    desc = "^" + desc;

    // Estes comandos fazem a lógica de busca do tipo contenha (porém a regra acima sempre sera executada primeiro.)
    desc = desc.replace(new RegExp("[%]", "gi"), ".*");
    desc = desc.replace(new RegExp("[&]", "gi"), ".*");
    desc = desc.replace(new RegExp("[(]", "gi"), "\\(");
    desc = desc.replace(new RegExp("[)]", "gi"), "\\)");

    let query = {
      selector: {
        type: { $eq: TYPE },
        status: { $eq: "A" },
      },
      limit: 12,
      skip: skip,
      fields: fieldsBusca,
    };

    if (filtro.familia !== null) {
      query.selector.idFamilia = { $eq: filtro.familia.idIntegracao };
    }

    if (filtro.grupo !== null) {
      query.selector.idGrupo = { $eq: filtro.grupo.idIntegracao };
    }

    if (pesquisaPrimeiraLetra) {
      query.selector.primeiraLetra = { $eq: primeiraLetra };
      query.sort = [
        { type: "asc" },
        { primeiraLetra: "asc" },
        { descFormat: "asc" },
      ];
    } else {
      query.sort = [{ type: "asc" }, { descFormat: "asc" }];
    }

    if (buscaPadrao === "descricao") {
      query.selector.descFormat = { $regex: desc };
    } else if (buscaPadrao === "cdBarras") {
      query.selector.cdBarras = {
        $elemMatch: {
          barra: {
            $eq: desc,
          },
        },
      };
    }

    // query = {
    //   selector: {
    //     type: { $eq: TYPE },
    //     status: { $eq: "A" },
    //   },
    //   limit: 25,
    //   skip: skip,
    //   fields: fieldsBusca,
    // };

    let result = await dbConnection.find(query);

    if (result.docs.length) {
      produtos = result.docs;

      for (let produto of produtos) {
        // produto.saldoReserva = await saldoReservaModel.getSaldoReserva(
        //   dbConnection,
        //   produto._id
        // );

        produto.saldoReserva = {
          qtd: 0,
        };

        produto.preco = getPrecoAtual(produto, tabelaPreco);
        produto = await getImagens(produto, dbConnection);

        delete produto.precoPadrao;
        delete produto.precoPromocional;

        if (parseFloat(produto.estoque.qtd) > 0) {
          produto.estoque.qtd =
            parseFloat(produto.estoque.qtd) - produto.saldoReserva.qtd;
        }

        // produto.ultimoPedido = await getHistoricoPedido(
        //   dbConnection,
        //   produto.idIntegracao,
        //   idIntegracaoCliente
        // );

        produto.ultimoPedido = null;

        if (produto.dtCadastro !== undefined) {
          let dataCadastro = moment(produto.dtCadastro).startOf("day");
          let dataAtual = moment().startOf("day");

          let duration = moment.duration(dataAtual.diff(dataCadastro));
          let diferenca = duration.asDays();

          if (diferenca <= parametros.diasProdutoNovo) {
            produto.isNovo = true;
          } else {
            produto.isNovo = false;
          }
        } else {
          produto.isNovo = false;
        }
      }

      // produtos = produtos.sort(function (a, b) {
      //   if (a.descFormat < b.descFormat) return -1;
      //   if (a.descFormat > b.descFormat) return 1;
      //   return 0;
      // });
    }

    return produtos;
  },

  findAll: async (
    dbConnection,
    idIntegracaoCliente,
    skip = 0,
    filtro = { familia: null, grupo: null }
  ) => {
    let produtos = [];
    //const configuracao = await dbConnection.get("configuracao");
    let parametros = await dbConnection.find(queryParametros);
    parametros = parametros.docs[0];

    let fieldsBusca = [].concat(fields);
    let tabelaPreco = null;

    if (idIntegracaoCliente !== "null") {
      idIntegracaoCliente = parseInt(idIntegracaoCliente);
      let cliente = await clienteModel.findTabelaPreco(
        dbConnection,
        idIntegracaoCliente
      );

      if (cliente.tabelaPreco !== null && cliente.tabelaPreco !== undefined) {
        fieldsBusca.push(`tabela-${cliente.tabelaPreco.idIntegracao}`);
        tabelaPreco = cliente.tabelaPreco;
      }
    }

    let query = {
      selector: {
        type: { $eq: TYPE },
        status: { $eq: "A" }
      },
      limit: 10,
      skip: skip,
      fields: fieldsBusca,
    };

    if (filtro.familia !== null) {
      query.selector.idFamilia = { $eq: filtro.familia.idIntegracao };
    }

    if (filtro.grupo !== null) {
      query.selector.idGrupo = { $eq: filtro.grupo.idIntegracao };
    }

    let result = await dbConnection.find(query);

    if (result.docs.length) {
      produtos = result.docs;

      for (let produto of produtos) {
        // produto.saldoReserva = await saldoReservaModel.getSaldoReserva(
        //   dbConnection,
        //   produto._id
        // );

        produto.saldoReserva = {
          qtd: 0,
        };

        produto.preco = getPrecoAtual(produto, tabelaPreco);
        produto = await getImagens(produto, dbConnection);

        delete produto.precoPadrao;
        delete produto.precoPromocional;

        if (parseFloat(produto.estoque.qtd) > 0) {
          produto.estoque.qtd =
            parseFloat(produto.estoque.qtd) - produto.saldoReserva.qtd;
        }

        // produto.ultimoPedido = await getHistoricoPedido(
        //   dbConnection,
        //   produto.idIntegracao,
        //   idIntegracaoCliente
        // );

        produto.ultimoPedido = null;

        if (produto.dtCadastro !== undefined) {
          let dataCadastro = moment(produto.dtCadastro).startOf("day");
          let dataAtual = moment().startOf("day");

          let duration = moment.duration(dataAtual.diff(dataCadastro));
          let diferenca = duration.asDays();

          if (diferenca <= parametros.diasProdutoNovo) {
            produto.isNovo = true;
          } else {
            produto.isNovo = false;
          }
        } else {
          produto.isNovo = false;
        }
      }
    }

    return produtos;
  },

  findFilters: async (dbConnection) => {
    let filters = {};
    let queryFamilia = {
      selector: {
        type: { $eq: "familia" },
      },
      limit: 9999,
    };

    let familia = await dbConnection.find(queryFamilia);

    let queryGrupo = {
      selector: {
        type: { $eq: "grupo" },
      },
      limit: 9999,
    };

    let grupo = await dbConnection.find(queryGrupo);

    filters = { familia: familia, grupo: grupo };
    return filters;
  },

  findAllPromocao: async (
    dbConnection,
    idIntegracaoCliente,
    skip = 0,
    filtro = { familia: null, grupo: null }
  ) => {
    let produtos = [];
    //const configuracao = await dbConnection.get("configuracao");
    let parametros = await dbConnection.find(queryParametros);
    parametros = parametros.docs[0];

    let fieldsBusca = [].concat(fields);
    let tabelaPreco = null;

    if (idIntegracaoCliente !== "null") {
      idIntegracaoCliente = parseInt(idIntegracaoCliente);
      let cliente = await clienteModel.findTabelaPreco(
        dbConnection,
        idIntegracaoCliente
      );

      if (cliente.tabelaPreco !== null && cliente.tabelaPreco !== undefined) {
        fieldsBusca.push(`tabela-${cliente.tabelaPreco.idIntegracao}`);
        tabelaPreco = cliente.tabelaPreco;
      }
    }

    let query = {
      selector: {
        type: { $eq: TYPE },
        status: { $eq: "A" },
        precoPromocional: { $ne: null },
        "precoPromocional.dtValidade": {
          $gte: moment().utc().format(),
        },
      },
      limit: 10,
      skip: skip,
      fields: fieldsBusca,
    };

    if (filtro.familia !== null) {
      query.selector.idFamilia = { $eq: filtro.familia.idIntegracao };
    }

    if (filtro.grupo !== null) {
      query.selector.idGrupo = { $eq: filtro.grupo.idIntegracao };
    }

    let result = await dbConnection.find(query);

    if (result.docs.length) {
      produtos = result.docs;

      for (let produto of produtos) {
        // produto.saldoReserva = await saldoReservaModel.getSaldoReserva(
        //   dbConnection,
        //   produto._id
        // );

        produto.saldoReserva = {
          qtd: 0,
        };

        produto.preco = getPrecoAtual(produto, tabelaPreco);
        produto = await getImagens(produto, dbConnection);

        delete produto.precoPadrao;
        delete produto.precoPromocional;

        if (parseFloat(produto.estoque.qtd) > 0) {
          produto.estoque.qtd =
            parseFloat(produto.estoque.qtd) - produto.saldoReserva.qtd;
        }

        // produto.ultimoPedido = await getHistoricoPedido(
        //   dbConnection,
        //   produto.idIntegracao,
        //   idIntegracaoCliente
        // );

        produto.ultimoPedido = null;

        if (produto.dtCadastro !== undefined) {
          let dataCadastro = moment(produto.dtCadastro).startOf("day");
          let dataAtual = moment().startOf("day");

          let duration = moment.duration(dataAtual.diff(dataCadastro));
          let diferenca = duration.asDays();

          if (diferenca <= parametros.diasProdutoNovo) {
            produto.isNovo = true;
          } else {
            produto.isNovo = false;
          }
        } else {
          produto.isNovo = false;
        }
      }
    }

    return produtos;
  },

  findById: async (dbConnection, idProduto, idIntegracaoCliente = null) => {
    let produto = null;
    //const configuracao = await dbConnection.get("configuracao");
    let parametros = await dbConnection.find(queryParametros);
    parametros = parametros.docs[0];

    let fieldsBusca = [].concat(fields);
    let tabelaPreco = null;

    if (idIntegracaoCliente !== null) {
      idIntegracaoCliente = idIntegracaoCliente;
      let cliente = await clienteModel.findTabelaPreco(
        dbConnection,
        idIntegracaoCliente
      );

      if (cliente.tabelaPreco !== null && cliente.tabelaPreco !== undefined) {
        fieldsBusca.push(`tabela-${cliente.tabelaPreco.idIntegracao}`);
        tabelaPreco = cliente.tabelaPreco;
      }
    }

    const q = {
      selector: {
        type: { $eq: "produto" },
        _id: idProduto,
      },
      fields: fieldsBusca,
    };
    let result = await dbConnection.find(q);

    if (result.docs.length) {
      produto = result.docs[0];
    }
    // produto.saldoReserva = await saldoReservaModel.getSaldoReserva(
    //   dbConnection,
    //   produto._id
    // );

    produto.saldoReserva = {
      qtd: 0,
    };

    produto.preco = getPrecoAtual(produto, tabelaPreco);
    produto = await getImagens(produto, dbConnection);

    produto.precoDetalhe = {};
    produto.precoDetalhe.precoPadrao = produto.precoPadrao;
    if (produto.preco.isPromo) {
      produto.precoDetalhe.precoPromocional = produto.precoPromocional;
    } else {
      produto.precoDetalhe.precoPromocional = null;
    }

    delete produto.precoPadrao;
    delete produto.precoPromocional;

    if (parseFloat(produto.estoque.qtd) > 0) {
      produto.estoque.qtd =
        parseFloat(produto.estoque.qtd) - produto.saldoReserva.qtd;
    }

    if (produto.dtCadastro !== undefined) {
      let dataCadastro = moment(produto.dtCadastro).startOf("day");
      let dataAtual = moment().startOf("day");

      let duration = moment.duration(dataAtual.diff(dataCadastro));
      let diferenca = duration.asDays();

      if (diferenca <= parametros.diasProdutoNovo) {
        produto.isNovo = true;
      } else {
        produto.isNovo = false;
      }
    } else {
      produto.isNovo = false;
    }
    return produto;
  },

  getImagemMedium: async (dbConnection, idProduto) => {
    let produto = null;

    const q = {
      selector: {
        type: { $eq: "produto" },
        _id: idProduto,
      },
      fields,
    };
    let result = await dbConnection.find(q);

    if (result.docs.length) {
      produto = result.docs[0];
      if (produto.imagens.length) {
        const queryImagemOffline = {
          selector: {
            type: { $eq: "imagemOffline" },
            "produto.idIntegracao": produto.idIntegracao,
          },
        };

        let resultImagem = await dbConnection.find(queryImagemOffline);

        if (resultImagem.docs.length) {
          return (
            "data:image/jpg;base64," +
            resultImagem.docs[0].imagens[0]["url_350x350"]
          );
        } else {
          return produto.imagens[0]["url_350x350"];
        }
      }
    }
    return null;
  },

  getImagemMediumLista: async (dbConnection, idProduto) => {
    let produto = null;
    let lista = [];

    const q = {
      selector: {
        type: { $eq: "produto" },
        _id: idProduto,
      },
      fields,
    };
    let result = await dbConnection.find(q);

    if (result.docs.length) {
      produto = result.docs[0];
      if (produto.imagens.length) {
        const queryImagemOffline = {
          selector: {
            type: { $eq: "imagemOffline" },
            "produto.idIntegracao": produto.idIntegracao,
          },
        };

        let resultImagem = await dbConnection.find(queryImagemOffline);

        if (resultImagem.docs.length) {
          let imagens = resultImagem.docs[0].imagens;

          for (let img of imagens) {
            lista.push("data:image/jpg;base64," + img["url_350x350"]);
          }
        } else {
          let imagens = produto.imagens;

          for (let img of imagens) {
            lista.push(img["url_350x350"]);
          }
        }
      }
    }
    return lista;
  },

  getGiro: async (dbConnection, idProduto) => {
    let produto = null;

    const q = {
      selector: {
        type: { $eq: "produto" },
        _id: idProduto,
      },
      fields: ["imagens", "giro", "_id", "idIntegracao"],
    };
    let result = await dbConnection.find(q);

    if (result.docs.length) {
      produto = result.docs[0];
      produto = await getImagens(produto, dbConnection);
      return produto;
    }
    return null;
  },

  findAllDestaque: async (dbConnection, skip = 0) => {
    let produtos = [];
    //const configuracao = await dbConnection.get("configuracao");
    let parametros = await dbConnection.find(queryParametros);
    parametros = parametros.docs[0];
    let query = {
      selector: {
        type: { $eq: TYPE },
        status: { $eq: "A" },
        dtCadastro: {
          $gte: moment()
            .startOf("day")
            .subtract(parametros.diasProdutoNovo, "days")
            .utc()
            .format(),
        },
      },
      limit: 10,
      skip: skip,
      fields: fields,
    };

    let result = await dbConnection.find(query);

    if (result.docs.length) {
      produtos = result.docs;

      for (let produto of produtos) {
        produto.saldoReserva = {
          qtd: 0,
        };

        produto.preco = getPrecoAtual(produto);
        produto = await getImagens(produto, dbConnection);

        delete produto.precoPadrao;
        delete produto.precoPromocional;

        if (parseFloat(produto.estoque.qtd) > 0) {
          produto.estoque.qtd =
            parseFloat(produto.estoque.qtd) - produto.saldoReserva.qtd;
        }

        produto.ultimoPedido = null;
        produto.isNovo = true;
      }
    }

    return produtos;
  },

  findEstoque: async (dbConnection, idProduto) => {
    let produto = null;

    const q = {
      selector: {
        type: { $eq: "produto" },
        _id: idProduto,
      },
      fields: ["_id", "estoque"],
      limit: 1,
    };

    let result = await dbConnection.find(q);

    if (result.docs.length) {
      produto = result.docs[0];
    }

    produto.estoque.qtd = parseFloat(produto.estoque.qtd);
    return produto.estoque.qtd;
  },
};

const getImagens = async (produto, dbConnection) => {
  if (produto.imagens === undefined) {
    produto.imagens = [
      {
        url_original: "",
        url_120x120: "../images/no-image.png",
        url_350x350: "../images/no-image.png",
        url_850x850: "../images/no-image.png",
        seq: 1,
        status: "A",
      },
    ];
  }
  if (produto.imagens.length === 0) {
    produto.imagens = [
      {
        url_original: "",
        url_120x120: "../images/no-image.png",
        url_350x350: "../images/no-image.png",
        url_850x850: "../images/no-image.png",
        seq: 1,
        status: "A",
      },
    ];
  }
  let resolucao = window.innerWidth;
  let descResolucao = "";
  if (resolucao < 768) {
    descResolucao = "url_120x120";
  } else {
    descResolucao = "url_350x350";
  }

  const queryImagemOffline = {
    selector: {
      type: { $eq: "imagemOffline" },
      "produto.idIntegracao": produto.idIntegracao,
    },
  };

  let result = await dbConnection.find(queryImagemOffline);

  if (result.docs.length) {
    produto.imagemPrincipal =
      "data:image/jpg;base64," + result.docs[0].imagens[0][descResolucao];
  } else {
    produto.imagemPrincipal = produto.imagens[0][descResolucao];
  }

  let imagensDetalhe = [];
  for (let i = 0; i < produto.imagens.length; i++) {
    // if (i !== 0) {
    //   imagensDetalhe.push(produto.imagens[i][descResolucao]);
    // }
    imagensDetalhe.push(produto.imagens[i][descResolucao]);
  }
  delete produto.imagens;
  delete produto.imgIntegracao;
  produto.imagens = imagensDetalhe;

  return produto;
};

const getPrecoAtual = (produto, tabelaPreco = null) => {
  let preco = {
    idIntegracao: produto.precoPadrao.idIntegracao,
    precoUnit: produto.precoPadrao.precoUnit,
    precoUnitComImpostos: produto.precoPadrao.precoUnitComImpostos,
    embPadrao: produto.precoPadrao.embPadrao,
    pDescMax: produto.precoPadrao.pDescMax,
    isPromo: false,
  };

  if (
    tabelaPreco !== null &&
    produto[`tabela-${tabelaPreco.idIntegracao}`] !== undefined
  ) {
    preco = {
      idIntegracao: produto[`tabela-${tabelaPreco.idIntegracao}`].idIntegracao,
      precoUnit: produto[`tabela-${tabelaPreco.idIntegracao}`].precoUnit,
      precoUnitComImpostos:
        produto[`tabela-${tabelaPreco.idIntegracao}`].precoUnitComImpostos,
      embPadrao: produto[`tabela-${tabelaPreco.idIntegracao}`].embPadrao,
      pDescMax: produto[`tabela-${tabelaPreco.idIntegracao}`].pDescMax,
      isPromo: false,
    };
  } else {
    if (produto.precoPromocional !== null) {
      if (
        moment().isSameOrBefore(moment(produto.precoPromocional.dtValidade))
      ) {
        preco = {
          idIntegracao: produto.precoPromocional.idIntegracao,
          precoUnit: produto.precoPromocional.precoUnit,
          precoUnitComImpostos: produto.precoPromocional.precoUnitComImpostos,
          embPadrao: produto.precoPromocional.embPadrao,
          pDescMax: produto.precoPromocional.pDescMax,
          isPromo: true,
        };
      }
    }
  }

  return preco;
};

const getHistoricoPedido = async (
  dbConnection,
  idIntegracaoProduto,
  idIntegracaoCliente
) => {
  let historico = await historicoPedidoModel.find(
    dbConnection,
    idIntegracaoProduto,
    parseInt(idIntegracaoCliente)
  );
  return historico;
};

const replaceCaracEspeciais = (text) => {
  text = text.replace(new RegExp("[ÁÀÂÃ]", "gi"), "A");
  text = text.replace(new RegExp("[ÉÈÊ]", "gi"), "E");
  text = text.replace(new RegExp("[ÍÌÎ]", "gi"), "I");
  text = text.replace(new RegExp("[ÓÒÔÕ]", "gi"), "O");
  text = text.replace(new RegExp("[ÚÙÛ]", "gi"), "U");
  text = text.replace(new RegExp("[Ç]", "gi"), "C");
  text = text.replace(new RegExp("[áàãâ]", "gi"), "a");
  text = text.replace(new RegExp("[éèê]", "gi"), "e");
  text = text.replace(new RegExp("[íìî]", "gi"), "i");
  text = text.replace(new RegExp("[óòõô]", "gi"), "o");
  text = text.replace(new RegExp("[úùû]", "gi"), "u");
  text = text.replace(new RegExp("[ç]", "gi"), "c");
  return text;
};

export default produtoModule;
